import React from 'react';
import PropTypes from 'prop-types';

import './PlayerHeader.css';

const PlayerHeader = ({player}) => {
  const team = player.team || {};

  return (
    <div className="PlayerHeader">
      <div className="background-image">
        <img className="background" alt={player.name} src={`http://cdn.nhle.com/logos/nhl/svg/${team.abbr}_light.svg?v=11.2`}/>
      </div>
      <div className="headshot-wrapper">
        <img className="headshot" alt="background" src={`http://static.nhle.com/mugs/mlbam/${player.id}@2x.png`}/>
      </div>
      <div className="team-wrapper">
        <img className="team" alt={team.name} src={`http://cdn.nhle.com/logos/nhl/svg/${team.abbr}_light.svg?v=11.2`}/>
      </div>
      <div className="text-wrapper">
        <div>
          <span className="name">{player.name}</span>
          <span className="team"><br/>{team.name}</span>
          <span className="number"><br/>{player.sweater ? '#' + player.sweater : ''}</span>
        </div>
      </div>
    </div>
  )
};

PlayerHeader.propTypes = {
  player: PropTypes.object.isRequired
};

export default PlayerHeader


// WEBPACK FOOTER //
// ./src/components/PlayerHeader.js